import { classIconSrc } from '../constants/pictograms';

export function classAvatar(cls?: string | null, stored?: string | null) {
  return classIconSrc(cls, stored);
}

export function barPercent(current: number | null | undefined, max: number | null | undefined) {
  const ceiling = max || 0;
  if (ceiling <= 0) return 0;
  return Math.max(0, Math.min(100, ((current || 0) / ceiling) * 100));
}
